export function getView(layout) {
  return ['all_images', 'misc', 'videos', 'itero'].includes(layout)
    ? 'No'
    : 'PrintContent'
}
